import { render, staticRenderFns } from "./CandidateResume.vue?vue&type=template&id=0cdfd796&scoped=true"
import script from "./CandidateResume.vue?vue&type=script&lang=ts"
export * from "./CandidateResume.vue?vue&type=script&lang=ts"
import style0 from "./CandidateResume.vue?vue&type=style&index=0&id=0cdfd796&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdfd796",
  null
  
)

export default component.exports